import React from 'react';
import { FadeIn } from './FadeIn';
import { Mail } from 'lucide-react';
import { CvDownloadButton } from './CvDownloadButton';
export function Contact() {
  return <section className="py-20 md:py-32 px-6 relative overflow-hidden" data-id="element-16" data-mp="35ahzi3okm4wa">
      {/* Decorative background element */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] md:w-[800px] h-[600px] md:h-[800px] bg-amber/5 rounded-full blur-3xl -z-10" data-id="element-17" data-mp="2w7qk5sskqozd" />

      <div className="max-w-2xl mx-auto text-center" data-id="element-18" data-mp="3szu4ssgs1stb">
        <FadeIn data-id="element-19" data-mp="3ovw8sqmr0y4h">
          <span className="text-sage font-medium tracking-widest uppercase text-xs md:text-sm mb-4 block" data-id="element-20" data-mp="3oxflk7974r1i">
            What's Next?
          </span>
          <h2 className="font-playfair text-4xl md:text-6xl text-charcoal mb-6 md:mb-8" data-id="element-21" data-mp="3f6cln8s06i3t">
            Let's Connect
          </h2>

          <p className="text-base md:text-lg text-charcoal/70 font-light mb-8 md:mb-10 leading-relaxed" data-id="element-22" data-mp="ggkxhxx25b7h">
            I'm looking for paralegal or legal assistant roles as I wrap up the
            UCLA program. If you've got an opening, know someone who does, or
            just want to chat, drop me a line.
          </p>

          <div className="flex flex-col items-center gap-7" data-id="element-23" data-mp="3ou62moz8lqd0">
            <a href="mailto:jacobpalkin@gmail.com" className="inline-flex items-center gap-3 rounded-full bg-charcoal px-7 py-3.5 text-base text-cream transition-colors duration-300 hover:bg-amber md:px-8 md:py-4 md:text-lg" data-id="element-24" data-mp="3b3sqsbj85rie">
              <Mail size={20} aria-hidden="true" data-id="element-25" data-mp="317g0lnmw1vse" />
              Say Hello
            </a>
            <CvDownloadButton data-id="element-26" data-mp="3623jn6z4hxzl" />
            <p className="text-charcoal/50 text-sm font-light italic tracking-wide" data-id="element-27" data-mp="2s4x0vceefzad">
              References available upon request.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}